<p class='header-style'>Federal Aviation Administration Categorical Exclusion Declaration</p>

<div style="margin: 10px" *ngIf="submission">
  <table class="catex-grid" width="100%">
    <tbody>
      <tr>
        <td>
          <strong>Date:</strong> {{submission.updatedAt | date:'MM/dd/yy'}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>IFP: {{designer?.name_email | mt}}</strong>
        </td>
      </tr>
      <tr>
        <td>
          <strong>Airport Contact: {{aptContact?.name_email | mt}}</strong>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <b>Request ID:</b> {{submission.requestId}} </div>
          <div>
            <b>Single or Multiple Procedure: </b> {{submission.isSingle? 'Single':'Multiple'}}
          </div>
          <div>
            <b>Procedure Name(s):</b>
            <tr *ngFor="let x of fullName">
                  <span>{{x}}</span>
            </tr>
          </div>
          <div>
              <b>Historic Properties: </b>{{submission.historicProperties}}
            </div>
            <div>            
            <b style="display: block">Procedure Request Description: </b>
            <span class="field-pre">{{procedureDescription}}</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <table class="catex-grid" width="100%" style="margin-top: 10px !important">
    <tbody>
      <tr>
        <td>
          <div>
            <b>Declaration of Exclusion:</b>
          </div>
          The FAA has reviewed the above referenced proposed action and it has been determined,
          by the undersigned, to be categorically excluded from further environmental documentation
          according to FAA Order 1050.1G, “FAA National Environmental Policy Act Implementing Procedures.”
          The implementation of this action will not result in any extraordinary circumstances
          in accordance with FAA Order 1050.1G.
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <b>Basis for this Determination:</b>
          </div>
          This review was conducted in accordance with policies and procedures in Department
          of Transportation Order 5610.1, "Procedures for Considering Environmental Impacts"
          and FAA Order 1050.1G.
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <b>The applicable Categorical Exclusion {{catex.length>1 ? 'are' : 'is'}}: </b>
          </div>
          <table class="catex-explanation">
            <tbody>
              <tr *ngFor="let c of catex">
                <td style="width: 65px"><b>{{c.code}}:</b></td>
                <td> {{c.val}} </td>
              </tr>
              <tr *ngIf="submission.isCatexEligible == null">
                <td style="width: 60px"><b>N/A:</b></td>
                <td>Procedure has not completed environmental specialist review.</td>
              </tr>
            </tbody>
          </table>
          <br>
          <table class="catex-grid" width="100%" border="1">
            <tbody>
              <tr>
                <td>
                  <b>The above flight procedure has been developed within the accepted parameters.</b>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span class="completed-by">Concurrence/Reviewed By:</span> <span class="concordance">&nbsp;</span>
                    <span class="date-label">Date:</span>&nbsp;<span class="date">&nbsp;</span>
                  </div>
                  <div>
                    <span class="completed-by">Title:</span>&nbsp;<span class="title">&nbsp;</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span class="completed-by">Approved By:</span>&nbsp;<span class="signature">&nbsp;</span>
                    <span class="date-label">Date:</span>&nbsp;<span class="date">&nbsp;</span>
                  </div>
                  <div>
                    <span class="completed-by">Title:</span>&nbsp;<span class="title">&nbsp;</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</div>